module.exports = __webpack_public_path__ + "img/110.eb7bc8f7.jpg";